import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useSiteContent } from "./siteContent";

const NavButton = ({ testid, onClick, ghost, children }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`group relative rounded-full px-4 py-2 text-xs uppercase tracking-[0.2em] transition-colors duration-300 md:px-6 md:text-sm ${
      ghost
        ? "text-[#F4F1EB] hover:text-white"
        : "bg-[#F4F1EB] text-[#102C1F] hover:bg-[#E5DFD3]"
    }`}
  >
    {children}
    {ghost && (
      <span className="absolute bottom-1 left-1/2 h-px w-0 -translate-x-1/2 bg-[#F4F1EB] transition-[width] duration-300 group-hover:w-2/3" />
    )}
  </button>
);

export default function Navbar({ onInicio, onEncomendar, onReservar }) {
  const [open, setOpen] = useState(false);
  const site = useSiteContent();
  const go = (fn) => () => {
    setOpen(false);
    fn();
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="admin-offset fixed inset-x-0 top-0 z-50 border-b border-[#F4F1EB]/10 bg-[#102C1F] text-[#F4F1EB]"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
        <button
          data-testid="nav-logo"
          onClick={go(onInicio)}
          className="font-display text-2xl italic tracking-tight md:text-3xl"
        >
          J'aime la vie
        </button>
        <nav className="hidden items-center gap-1 md:flex md:gap-3">
          <NavButton testid="nav-inicio-btn" onClick={onInicio} ghost>
            {site.nav_home}
          </NavButton>
          <NavButton testid="nav-encomendar-btn" onClick={onEncomendar}>
            {site.nav_order}
          </NavButton>
          <NavButton testid="nav-reservar-btn" onClick={onReservar}>
            {site.nav_reserve}
          </NavButton>
        </nav>
        <button
          data-testid="nav-menu-btn"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
          className="rounded-full border border-[#F4F1EB]/25 p-2 transition-colors duration-300 hover:bg-[#F4F1EB]/10 md:hidden"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-[#F4F1EB]/10 bg-[#102C1F] px-5 pb-5 pt-2 md:hidden"
        >
          <button
            data-testid="nav-inicio-btn-mobile"
            onClick={go(onInicio)}
            className="block w-full border-b border-[#F4F1EB]/10 py-3.5 text-left text-xs uppercase tracking-[0.2em] text-[#F4F1EB]"
          >
            {site.nav_home}
          </button>
          <button
            data-testid="nav-encomendar-btn-mobile"
            onClick={go(onEncomendar)}
            className="block w-full border-b border-[#F4F1EB]/10 py-3.5 text-left text-xs uppercase tracking-[0.2em] text-[#F4F1EB]"
          >
            {site.nav_order}
          </button>
          <button
            data-testid="nav-reservar-btn-mobile"
            onClick={go(onReservar)}
            className="mt-4 w-full rounded-full bg-[#F4F1EB] py-3 text-xs uppercase tracking-[0.2em] text-[#102C1F]"
          >
            {site.nav_reserve}
          </button>
        </nav>
      )}
    </motion.header>
  );
}
